var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_2956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H7V4H8V2.5H15C15.3 2.5 15.5 2.7 15.5 3V8.5C15.5 8.8 15.3 9 15 9H8.5V12.5H5.85L4 13.95V12.5H2.5C2.2 12.5 2 12.3 2 12V6.5C2 6.2 2.2 6 2.5 6H9V5H2.5C1.65 5 1 5.65 1 6.5V12C1 12.85 1.65 13.5 2.5 13.5H3V16.05L6.15 13.5H9.5V10H15C15.85 10 16.5 9.35 16.5 8.5V3C16.5 2.15 15.85 1.5 15 1.5Z",
    fill: "#F99B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09998 11.45H4.29998L4.59998 10.65H6.14998L6.44998 11.45H7.64998L5.94998 7H4.74998L3.09998 11.45ZM5.34998 8.25L5.84998 9.8H4.84998L5.34998 8.25Z",
    fill: "#F99B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10.55 8.5 11.3 8.35 12 8C12.7 8.35 13.5 8.5 14 8.5V7.5C14 7.5 13.5 7.5 12.95 7.3C13.55 6.7 14 5.8 14 4.5V4H12.5V3H11.5V4H10V5H12.95C12.85 5.9 12.45 6.45 12 6.8C11.7 6.55 11.4 6.2 11.2 5.75H10.15C10.35 6.4 10.65 6.9 11.05 7.3C10.55 7.5 10.1 7.5 10 7.5V8.5Z",
    fill: "#F99B28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_2956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.b2bbd76709057963d554749f622577bb.svg";
export { ForwardRef as ReactComponent };